export const TREE_CREATION_MODES = Object.freeze({
  WIDGET: 'widget',
  LIBRARY_APP: 'library-app',
});

export const DEFAULT_TREE_CREATION_MODE = TREE_CREATION_MODES.WIDGET;
